module.exports = __webpack_public_path__ + "img/collapse-delete.3b139a91.svg";